import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { logo } from '../../../../../configs/Icons';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import { ButtonPrimary } from '../../../../utils/Button';
import { InputPassword } from '../../../../utils/InputField';
import { mkRelativeUrl } from '../../../../utils/URL';
import { handleUpdatePasswordOpe } from '../../UserControlOperation';
import { useForgotPassword } from '../ForgottenProvider';

function UpdatePassword() {
    const navigate = useNavigate();
    const { setMessage } = useTemplate();
    const { formData, handleChange, setIsError } = useForgotPassword();
    const [loading, setLoading] = useState(false);

    // Focus on Input Field
    useEffect(() => {
        document.getElementsByTagName('input')[0].focus();
    }, []);

    // -- Update Password Function
    const handleUpdatePassword = (e) => {
        e?.preventDefault();
        setLoading(true);
        handleUpdatePasswordOpe(formData, setIsError)
            .then(({ title }) => {
                navigate(mkRelativeUrl('/login'));
                setMessage({ type: 'success', text: title });
            })
            .catch((err) => {
                setLoading(false);
                setMessage({ type: 'error', text: err.toString(0) });
            });
    };

    return (
        <div className="h-[calc(100vh_-_60px)] md:h-screen w-screen flex items-center justify-center bg-transparent px-4 relative">
            <form
                onSubmit={handleUpdatePassword}
                className="w-[430px] shadow-[0px_4px_50px_0px_rgba(4,43,58,0.03)] mx-auto flex flex-col justify-between items-center gap-y-4 bg-white p-16 rounded-[30px] relative"
            >
                <div className="logo mb-3.5">
                    <img src={logo?.mainLogoW} alt="" />
                </div>
                <div className="w-full">
                    <h1 className="text-base font-medium text-primary-700">
                        <span className="inline-block border-b border-secondary leading-8">
                            Update
                        </span>
                        &nbsp; New Password
                    </h1>
                </div>

                <InputPassword
                    name="Password1"
                    placeholder="New Password"
                    formData={formData}
                    onChange={handleChange}
                    height="h-10"
                />
                <InputPassword
                    name="Password2"
                    placeholder="Confirm Password"
                    formData={formData}
                    onChange={handleChange}
                    height="h-10"
                />
                <p className="text-sm text-error font-normal">
                    Password must be contain one uppercase letter, one lowercase letter, one digit
                    and one special character and minimum length is eight characters.
                </p>
                <div className="flex justify-end items-center w-full">
                    <ButtonPrimary title="Update" btnType="submit" loading={loading} />
                </div>
            </form>
        </div>
    );
}

export default UpdatePassword;
